export const newUserActionType = 'USERS';
export const userActionDelete = 'DELETE';
export const proctuctJeweleryActionType = 'JEWELERY';
export const productElectronicActionType = 'ELECTRONICS';
export const addtocart = 'ADDTOCART';
